import { Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'

import Icon, { IconName } from 'components/Icon'
import theme from 'theme'

export const DrawerUserDetail: React.FC<{
  iconName: IconName
  text: string
}> = ({ iconName, text }) => (
  <>
    <Grid item css={{ textAlign: 'center' }} xs={2}>
      <Icon css={{ marginRight: theme.space[1] }} icon={iconName} />
    </Grid>

    <Grid item zeroMinWidth xs={10}>
      <Tooltip arrow title={text}>
        <Typography noWrap>{text}</Typography>
      </Tooltip>
    </Grid>
  </>
)
